import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, map, mergeMap, of } from 'rxjs'
import { route_to_action, show_display_id_after_created_action, show_error_action } from '../action/common/common.action'
import {
  fetch_calendar_details,
  fetch_calendar_details_success,
  load_calendar_summary_action,
  load_calendar_summary_success_action,
  save_calendar_action,
  save_calendar_success_action,
  update_calendar_action,
  update_calendar_success_action
} from '../action/calendar.action'
import { CalendarService } from 'src/app/services/calendar/calendar.service'

@Injectable()
export class CalendarEffects {
  constructor(private actions$: Actions, private calendarService: CalendarService) {}
  load_calendar_summary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(load_calendar_summary_action),
      mergeMap(data =>
        this.calendarService.invokeCalendarSummaryAPI(data.queryParams, data.searchRequestBody).pipe(
          map(calendarResponce => load_calendar_summary_success_action({ calendar: calendarResponce })),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  save_calendar_action$ = createEffect(() =>
    this.actions$.pipe(
      ofType(save_calendar_action),
      mergeMap(({ calendar, files, routeTo }) =>
        this.calendarService.callSaveApi(calendar, files).pipe(
          mergeMap(response => [
            save_calendar_success_action({
              calendar: response
            }),
            route_to_action({ routeTo }),
            show_display_id_after_created_action({moduleName: 'Calendar Event', displayId: response?.displayId})
          ]),

          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  update_calendar_action$ = createEffect(() =>
    this.actions$.pipe(
      ofType(update_calendar_action),
      mergeMap(({ id, calendar, files, routeTo }) =>
        this.calendarService.callUpdateApi(id, calendar, files).pipe(
          mergeMap(response => [
            update_calendar_success_action({
              calendar: response
            }),
            route_to_action({ routeTo })
          ]),

          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  fetch_calendar_details$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetch_calendar_details),
      mergeMap(({ id }) =>
        this.calendarService.callCalendarDetailsApi(id).pipe(
          mergeMap(calendar => [fetch_calendar_details_success({ calendar })]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )
}
